import { FileConvertS3UrlGenerate } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
export const GetPresignedUrlForS3Upload = {
  data() {
    return {
      overlay: false,
      PresignedUrlForS3Upload: "",
    };
  },
  methods: {
    async GetPresignedUrlForS3UploadMethod(key) {
      try {
        this.overlay = true;
        let result = await API.graphql(
          graphqlOperation(FileConvertS3UrlGenerate, {
            input: {
              key: key,
            },
          })
        );
        this.PresignedUrlForS3Upload = JSON.parse(
          result.data.FileConvertS3UrlGenerate
        ).message;
        // console.log(
        //   "PresignedUrlForS3Upload:-->",
        //   JSON.parse(result.data.FileConvertS3UrlGenerate)
        // );
        this.overlay = false;
      } catch (error) {
        // console.log("error in getpresignedurl", error);
        this.overlay = false;
      }
    },
  },
};
